import { BaseApi } from './base.api'
import { METHOD_AXIOS } from '../utils/constant'

function toQuery(params = {}) {
	const q = new URLSearchParams()
	Object.keys(params).forEach(key => {
		const value = params[key]
		if (value === undefined || value === null || value === '') return
		q.set(key, String(value))
	})
	return q.toString()
}

export class VoucherAdminApi extends BaseApi {
	constructor() {
		super('api/admin/voucher-codes')
	}

	async list(params = {}) {
		const qs = toQuery(params)
		return this.get(qs ? `?${qs}` : '')
	}

	async listGroups(params = {}) {
		const qs = toQuery(params)
		return this.get(qs ? `groups?${qs}` : 'groups')
	}

	async create(data) {
		return this.requestJson('', data, METHOD_AXIOS.POST)
	}

	async updateNotes(id, notes) {
		return this.requestJson(`/${id}`, { notes }, METHOD_AXIOS.PUT)
	}

	async updateGroupNotes(id, notes) {
		return this.requestJson(`/groups/${id}`, { notes }, METHOD_AXIOS.PUT)
	}

	async remove(id) {
		return this.delete(`/${id}`)
	}
}
